import React, { useEffect, useState } from 'react';
import axios from 'axios';
import { Link } from 'react-router-dom';
import BASE_URL from '../../../config/config';
import './css/admin_style.css';

const AdminPrePanel = () => {
  const [usuarios, setUsuarios] = useState([]);
  const [longitudUsuarios, setLongitudUsuarios] = useState(0);
  const [totalTickets, setTotalTickets] = useState(0);
  const [totalProyectos, setTotalProyectos] = useState(0);

  const handleLinkClick = () => {
    window.scrollTo({ top: 0});
};

  useEffect(() => {
    const fetchUsuarios = async () => {
      try {
        const response = await axios.get(`${BASE_URL}/todos-usuarios-conteo`);
        const usuarios = response.data.total || 0;
        console.log(usuarios)
        setUsuarios(usuarios);
        setLongitudUsuarios(usuarios);
      } catch (error) {
        console.error('Error al obtener los usuarios:', error);
      }
    };


    const fetchTotalTickets = async () => {
      try {
        const response = await axios.get(`${BASE_URL}/tickets/total-conteo`);
        console.log(response)
        const tickets = response.data.total || 0;
        setTotalTickets(tickets);
      } catch (error) {
        console.error('Error al obtener los tickets:', error);
      }
    };

    const fetchTotalProyectos = async () => {
      try {
        const response = await axios.get(`${BASE_URL}/proyectos`);
        console.log(response.data)
        const proyectos = response.data.proyectos.length || 0;
        setTotalProyectos(proyectos);
      } catch (error) {
        console.error('Error al obtener los proyectos:', error);
      }
    };

    fetchUsuarios();
    fetchTotalTickets();
    fetchTotalProyectos();
  }, []);


  return (
    <div className="admin-prepanel-grid">
          <div className='admin-prepanel'>
        <Link to={'/dashboard/tickets'} className='prepanel-card prepanel-tickets' onClick={handleLinkClick}>
          <div className="cabecera-prepanel-card">
            <img src="/images/billete.svg" alt="Ticket" className='dash-icon-tickets'/>
            <h3>Gestionar Tickets</h3>
          </div>
            <p className='prepanel-resume'>Responde y administra tickets por tu departamento.</p>

            <div className="info-prepanel-card">
              <div className='prepanel-data'>
                <p>{totalTickets}</p>
                <p>Incidencias abiertas</p>
              </div>
              <div className="prepanel-estado">
                <p>Activo</p>
              </div>
            </div>
            <button>Ir al panel</button>
        </Link>

        <Link to={'/dashboard/users'} className='prepanel-card prepanel-usuarios' onClick={handleLinkClick}>
          <div className="cabecera-prepanel-card">
            <img src="/images/usuarios-alt.svg" alt="Usuarios" className='dash-icon-users'/>
            <h3>Gestionar Usuarios</h3>
          </div>
          <p className='prepanel-resume'>Administra y verifica los usuarios de la plataforma.</p>

          <div className="info-prepanel-card">
            <div className='prepanel-data'>
              <p>{longitudUsuarios}</p>
              <p>Usuarios registrados</p>
            </div>
            <div className="prepanel-estado">
              <p>Activo</p>
            </div>
          </div>
          <button>Ir al panel</button>
        </Link>

        <Link to={'/dashboard/tracking-proyectos'} className='prepanel-card prepanel-proyectos' onClick={handleLinkClick}>
          <div className="cabecera-prepanel-card">
            <img src="/images/carpeta-abierta.svg" alt="Proyectos" className='dash-icon-proyectos'/>
            <h3>Tracking de Proyectos</h3>
          </div>
          <p className='prepanel-resume'>Informa al cliente de las fases de realización de su proyecto.</p>

          <div className="info-prepanel-card">
            <div className='prepanel-data'>
              <p>{totalProyectos}</p>
              <p>Proyectos activos</p>
            </div>
            <div className="prepanel-estado">
              <p>Activo</p>
            </div>
          </div>
          <button>Ir al panel</button>
        </Link>
    </div>
    <div className="grid-prepanel-ajustes">
    <Link to={'/dashboard/equipos'} className='prepanel-card prepanel-ajustes' onClick={handleLinkClick}>
          <div className="cabecera-prepanel-card">
            <img src="/images/computadora.svg" alt="Proyectos" className='dash-icon-ajustes'/>
            <h3>Equipos informáticos</h3>
          </div>
          <p className='prepanel-resume'>Control de equipos y periféricos de la oficina.</p>

    
          <button>Ir al panel</button>
        </Link>

        <Link to={'/dashboard/ajustes-del-sistema'} className='prepanel-card prepanel-ajustes' onClick={handleLinkClick}>
          <div className="cabecera-prepanel-card">
            <img src="/images/ajustes.svg" alt="Proyectos" className='dash-icon-ajustes'/>
            <h3>Ajustes del sistema</h3>
          </div>
          <p className='prepanel-resume'>Configura las notificaciones globales y mucho más.</p>

    
          <button>Ir al panel</button>
        </Link>
      </div>
    </div>
  );
};

export default AdminPrePanel;
